import { render } from "./FieldsEmotional.vue?vue&type=template&id=5a84a55d"
import script from "./FieldsEmotional.vue?vue&type=script&lang=js"
export * from "./FieldsEmotional.vue?vue&type=script&lang=js"
script.render = render

export default script